<!--
 * @ Author: Your name
 * @ Create Time: 2019-07-16 10:38:23
 * @ Modified by: Your name
 * @ Modified time: 2019-07-22 17:36:05
 * @ Description: 获取客户端日志弹窗
 -->
<template>
  <div>
    <div class="tool-bars">
      <el-form :model="formData" label-width="110px" label-position="right"
        :inline="true" :rules="rules" ref='clientLogDialog'>
        <el-form-item label="获取日志时间" prop="time">
          <el-date-picker
            v-model="formData.time"
            size='small'
            type="daterange"
            format="yyyy-MM-dd"
            value-format='yyyy-MM-dd'
            range-separator="-"
            :picker-options="pickerOptionsStart"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" size="small" icon="el-icon-search"
          @click="searchClientLog" :disabled="getClientLogBtn">获取客户端日志</el-button>
        <el-button type="success" size="small" icon="el-icon-delete"
          @click="deleteServeLog">清空全部日志</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      class="client-log-table" border
      :loading='tableLoading'
      style="width: 100%">
      <el-table-column
        prop="deviceNumber"
        label="柜门编号"
        align="center"/>
      <el-table-column
        prop="startDate"
        label="开始时间"
        align="center"/>
      <el-table-column
        prop="endDate"
        label="结束时间"
        align="center"/>
      <el-table-column
        prop="ftpPath"
        show-overflow-tooltip
        label="文件地址"
        align="center"/>
      <el-table-column
        prop="createDate"
        align="center"
        :formatter='formatterTime'
        show-overflow-tooltip
        label="上传时间"/>
      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <a @click="downloadLog(scope.row.ftpPath)"
            href="javascript:void(0)">下载日志</a>
          <a @click="deleteLog(scope.row.ftpPath, scope.row.uuid)"
            href="javascript:void(0)">删除日志</a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { DEVICE_MANAGE } from '../../libs/api'
import { saveFile } from '../../libs/utils/file'
import { parseTime } from '../../libs/utils/parseTime'

export default {
  name: 'dialogClientLog',
  props: {
    deviceNumber: String,
    timeStamp: Number
  },
  data() {
    return {
      formData: {
        deviceNumber: this.deviceNumber,
        startDate: '',
        endDate: '',
        time: ''
      },
      throttleFn: '',
      getClientLogBtn: false,
      tableLoading: false,
      rules: {
        time: { required: true, message: '请选择获取日志时间', trigger: 'change' }
      },
      choiceDate: '', // 选择的日期
      pickerOptionsStart: { // 设置获取日志时间范围为一周
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate = minDate.getTime()
          if (maxDate) {
            this.choiceDate = ''
          }
        },
        disabledDate: time => {
          if (this.choiceDate) {
            const one = 7 * 24 * 3600 * 1000
            const minTime = this.choiceDate - one
            const maxTime = this.choiceDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
          return ''
        }
      },
      tableData: [],
      findLogUrl: DEVICE_MANAGE.FIND_LOG,
      insertLogUrl: DEVICE_MANAGE.INSERT_LOG,
      downloadUrl: DEVICE_MANAGE.CLIENT_DOWNLOAD_LOG,
      deleteFileUrl: DEVICE_MANAGE.DELETEFILE,
      clearLogUrl: DEVICE_MANAGE.CLEARLOG
    }
  },
  watch: {
    timeStamp() {
      // 重置日期值
      this.$refs.clientLogDialog.resetFields()
      this.findLog()
      this.getClientLogBtn = false // 获取客户端日志loading
    }
  },
  created() {
    this.findLog()
    this.throttleFn = this.throttle(this.getClientLog, 1000 * 60)
  },
  methods: {
    formatterTime(row, column, cellValue) {
      if (cellValue) return parseTime(cellValue)
      return cellValue
    },
    findLog() {
      this.tableLoading = true
      this.$http.post(this.findLogUrl, { deviceNumber: this.deviceNumber })
        .then(res => {
          if (res.data.code !== 1) {
            this.handleNotify('error', '错误', res.data.msg || '获取日志列表失败')
          }
          this.tableData = res.data.data
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    searchClientLog() { // 查询日志
      this.$refs.clientLogDialog.validate(valid => {
        if (valid) {
          this.getClientLogBtn = true
          this.throttleFn() // 函数节流
          setTimeout(() => {
            this.getClientLogBtn = false // 获取客户端日志loading
          }, 1000 * 60)
        } else {
          console.log('error submit!!')
          return false
        }
        return ''
      })
    },
    getClientLog() {
      const param = this.formatFormData()
      this.tableLoading = true
      this.$http.post(this.insertLogUrl, param)
        .then(res => {
          this.tableLoading = false
          if (res.data.code !== 1) {
            this.handleNotify('error', '错误', res.data.msg || '获取客户端日志失败')
            return
          }
          this.findLog()
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    throttle(fn, interval) { // 函数节流 规定在一个单位时间内。只能触发一次函数
      let lastTime = ''
      /* eslint-disable */
			return function () {
				let nowTime = Date.now()
				if (nowTime - lastTime > interval) {
          lastTime = nowTime
          fn()
				}
			}
    },
    formatFormData() { // 格式化formdata数据
      const param = { ...this.formData }
      const { time } = this.formData
      /* eslint-disable */ 
      param.startDate = time[0]
      param.endDate = time[1]
      delete param.time
      return param
    },
    deleteServeLog() { // 清空服务器日志
      this.$http.post(this.clearLogUrl, { deviceNumber: this.deviceNumber })
        .then(res => {
          if (res.data.code !== 1) {
            this.handleNotify('error', '错误', res.data.msg || '清空全部日志失败')
          }
          this.findLog()
        })
    },
    downloadLog(ftpPath) { // 下载日志
      this.$http.post(this.downloadUrl, { ftpPath })
        .then(res => {
          if (ftpPath === '' || ftpPath === null) {
            this.handleNotify('error', '错误', '文件不存在')
            return
          }
          if (res.data.code !== 1) {
            this.handleNotify('error', '错误', res.data.msg || '文件下载失败')
            return
          }
          const { fileName, file } = res.data.data
          saveFile(fileName, file, 'application/xml')
        })
    },
    deleteLog(ftpPath, uuid) { // 删除日志
      if (ftpPath === null || ftpPath === '') {
        this.handleNotify('error', '错误', '文件不存在')
        return
      }
      this.$http.post(this.deleteFileUrl, { ftpPath, uuid })
        .then(res => {
          if (res.data.code === 1) {
            this.handleNotify('success', '提示', '删除文件成功！')
            this.findLog()
          } else {
            this.handleNotify('error', '错误', res.data.msg || '删除文件失败！')
          }
        })
    },
    handleNotify(type, title, message) {
      this.$notify({
        type,
        title,
        message
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .tool-bars{
    display: flex;
    align-items: center;
    justify-content: space-around;
    background: #f0f0f0db;
    padding: 5px 10px;
    margin-bottom: 10px;
    border-radius: 8px;
    .el-form-item{
      margin-bottom: 0px;
    }
  }
  a{
    color: #409EFF;
    margin: 0 10px
  }
</style>
